// realtime.js — socket.io singleton authenticated with the JWT access token.
// The backend validates the token at connect time and auto-joins the
// organization room; conversation rooms are joined on demand.
import { io } from 'socket.io-client';

let socket = null;

export function connect() {
    const token = localStorage.getItem('access_token');
    if (!token) return null;
    if (socket) return socket;

    const base = window.location.hostname === 'localhost'
        ? 'http://localhost:5000'
        : '/';

    socket = io(base, {
        auth: { token },
        reconnection: true,
        reconnectionDelayMax: 10000
    });

    // The token may have been refreshed since connect — retry with the
    // current one instead of looping on a stale credential.
    socket.on('connect_error', () => {
        const fresh = localStorage.getItem('access_token');
        if (socket && fresh && socket.auth?.token !== fresh) {
            socket.auth = { token: fresh };
        }
    });

    return socket;
}

export function on(event, callback) {
    const s = connect();
    if (!s) return () => {};
    s.on(event, callback);
    return () => s.off(event, callback);
}

export function joinConversation(conversationId) {
    connect()?.emit('join_conversation', { conversation_id: conversationId });
}

export function leaveConversation(conversationId) {
    socket?.emit('leave_conversation', { conversation_id: conversationId });
}

export function disconnect() {
    socket?.disconnect();
    socket = null;
}
